import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Grid,
  Menu,
  MenuItem,
  Badge,
  Typography,
  IconButton,
  Toolbar,
  Box,
  AppBar,
  Avatar,
  Switch,
  FormGroup,
  FormControlLabel,
} from '@mui/material';
import MoreIcon from '@mui/icons-material/MoreVert';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import {
  getNotificationCount,
  getNotificationSeen,
} from 'redux/actions/UserNotification';
import { getProfile } from 'redux/actions/UserProfile';
import { getSosAlert } from 'redux/actions/UserTrip';
import { getMagicToken } from 'redux/actions/UserLogin';
import { appBarStyle } from './HeaderStyle';
import CommonSosDialog from 'components/commonSosDialog/CommonSosDialog';
import { companyDetailsEnum } from 'utils/companyDetails';
import profile from 'assets/images/profileImg.svg';
import notification from 'assets/images/notificationIcon.svg';

function Header(props) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [pageName, setPageName] = useState('');
  const [rideTrackDetails, setRideTrackDetails] = useState('');
  const location = useLocation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState(null);
  let tableData = useSelector(
    (state) => state?.userNotificationCount?.userNotificationCount?.data
  );
  const userProfileData = useSelector(
    (state) => state?.userProfile?.userProfile?.data
  );
  const sosAlertData = useSelector(
    (state) => state?.userSOSAlert?.userSOSAlert
  );
  const role = localStorage.getItem('role');
  const token = localStorage.getItem('token');
  const businessType = localStorage.getItem('businessType');
  const isVendorPresent = role === 'vendorCompany';
  const status = localStorage.getItem('status');
  const PendingStatus = status === 'Pending';
  const filterData = {
    id: '',
  };
  useEffect(() => {
    dispatch(getProfile());
  }, []);

  useEffect(() => {
    const data = window.location.href;
    const paramsVal = data?.split('/')[3];
    if (paramsVal === 'notification') {
      tableData = { ...tableData, notificationsCount: 0 };
    } else {
      dispatch(getNotificationCount(filterData));
    }
    setPageName(paramsVal?.split('?')[0]);
    setRideTrackDetails(data?.split('/')[4]?.split('?')[0]);
  }, [location]);

  const handleOnError = (e) => {
    e.target.src = profile;
  };

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const isPopoverMenuOpen = Boolean(popoverOpen);

  const handleProfileMenuOpen = () => {
    window.location.replace('/settings');
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handlePopoverMenuOpen = (event) => {
    setPopoverOpen(event.currentTarget);
  };

  const handlePopoverMenuClose = () => {
    setPopoverOpen(null);
  };

  const onNotification = () => {
    dispatch(getNotificationSeen());
    window.location.replace('/notification');
  };

  const onClickSOS = () => {
    dispatch(getSosAlert());
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSwitchBtn = () => {
    //API calling for magic token and this magic token
    dispatch(getMagicToken());
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {/* // TODO: will use for after notification API is added */}
      {/* <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={tableData?.notificationsCount} color="error">
            <img src={notification} alt="notification icon" />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem> */}
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <img
            className="wh50"
            src={
              userProfileData?.avatar?.url &&
              userProfileData?.avatar?.url !== null
                ? userProfileData?.avatar?.url
                : profile
            }
            alt="profile"
            onError={handleOnError}
          />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  const popoverMenuId = 'primary-switch-account-menu';
  const renderPopoverMenu = (
    <Menu
      anchorEl={popoverOpen}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={popoverMenuId}
      keepMounted
      open={isPopoverMenuOpen}
      onClose={handlePopoverMenuClose}
    >
      <MenuItem className="bgWhite" onClick={() => handleSwitchBtn()}>
        <Avatar
          alt="Admin"
          src={
            userProfileData?.avatar?.url &&
            userProfileData?.avatar?.url !== null
              ? userProfileData?.avatar?.url
              : profile
          }
          onError={handleOnError}
          className="width50"
        />
        <Typography className="paddingleft10 fw500 colorBlack font12">
          {companyDetailsEnum?.companyLogoDark} B2B
        </Typography>
      </MenuItem>
    </Menu>
  );

  function generateGreeting(pageName) {
    switch (pageName) {
      case 'dashboard': {
        const currentTime = new Date();
        const hours = currentTime.getHours();

        if (hours >= 5 && hours < 12) {
          return 'Good Morning';
        } else if (hours >= 12 && hours < 17) {
          return 'Good Afternoon';
        } else {
          return 'Good Evening';
        }
      }
      case 'vendor':
        return 'City Manager';
      case 'subvendor':
        return 'Sub Vendor';
      case 'customer':
        return 'Customer';
      case 'driver':
        return 'Driver';
      case 'feedback':
        return 'Feedback';
      case 'compliance':
        return 'Compliance';
      case 'notification':
        return 'Notification';
      case 'rideTrack':
        return 'Track Trip';
      case 'settings':
        return 'Settings';
      case 'addcomplaince':
        return 'Configuration';
      case 'addfeedback':
        return 'Configuration';
      case 'addcabcategory':
        return 'Configuration';
      case 'support':
        return 'Support';
      case 'invoice':
        return 'Invoice';
      case 'reports':
        return 'Report';
      case 'faq':
        return 'Configuration';
      case 'policy':
        return 'Policy';
      case 'ratecard':
        return 'Configuration';
      case 'assignvechile':
        return 'Assign Vehicle';
      case 'assigndriver':
        return 'Assign Driver';
      case 'assigntrip':
        return 'Assign Trip';

      default:
        return pageName.charAt(0).toUpperCase() + pageName.slice(1) || 'Hello';
    }
  }

  const greeting = generateGreeting(pageName);

  const [isB2B, setIsB2B] = useState(businessType === 'isB2B' ? true : false);

  const handleSwitchChange = (event) => {
    setIsB2B(event.target.checked);
    let switchStatus = '';
    if (event.target.checked) {
      switchStatus = 'isB2B';
    } else {
      switchStatus = 'isB2C';
    }
    localStorage.setItem('businessType', switchStatus);
    if (rideTrackDetails === 'bookingdetails') {
      navigate(`/rideTrack/1`);
    }else if (rideTrackDetails === 'details') {
      navigate(`/rideTrack/2`);
    }else {
      window.location.reload();
    }
  };

  return (
    <div>
      <Box>
        <AppBar position="static" style={appBarStyle}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={props.handelOnlyOnMobile}
              sx={{ mr: 2, display: { sm: 'none', xs: 'flex' } }}
            >
              <MenuIcon />
            </IconButton>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className="height86"
            >
              <Grid item xs={5}>
                {pageName === 'dashboard' && (
                  <Typography className="colorGrey font14 fontSemi">
                    <p className="marginBlock0">
                      {role === 'subVendorCompany'
                        ? 'Hi, Sub-Vendor'
                        : role === 'vendorCompany'
                        ? 'Hi, City Manager'
                        : 'Hi, Admin'}
                    </p>
                  </Typography>
                )}
                <Typography variant="h6" noWrap component="div">
                  <p
                    className={
                      pageName === 'dashboard'
                        ? 'font20 fontMedium marginBlock0'
                        : 'font20 fontMedium marginBlock'
                    }
                  >
                    {greeting}
                  </p>
                </Typography>
              </Grid>

              <Grid
                container
                item
                xs={7}
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                {/* <Grid item xs={4} container alignItems={"center"}>
                  <Typography pr={2} className='font18'> <span className='colorGrey'>You logged into</span> {isB2B ? 'B2B' : 'B2C'}</Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isB2B}
                          onChange={handleSwitchChange}
                          name="isB2B"
                          color="primary"
                          disabled={parseInt(userProfileData?.businessType) !== 2}
                        />
                      }
                    />
                  </FormGroup>
                </Grid> */}

                <Grid item className="vendorIcons justifyEnd">
                  <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                    <IconButton
                      size="large"
                      aria-label="show 17 new notifications"
                      color="inherit"
                      className="filterBtn"
                      onClick={() => {
                        onNotification();
                      }}
                      disabled={
                        PendingStatus
                          ? true
                          : role === 'subVendorCompany'
                          ? true
                          : false
                      }
                    >
                      <Badge
                        badgeContent={tableData?.notificationsCount}
                        color="error"
                      >
                        <img src={notification} alt="notification icon" />
                      </Badge>
                    </IconButton>
                    <IconButton
                      size="large"
                      edge="end"
                      aria-label="account of current user"
                      aria-controls={menuId}
                      aria-haspopup="true"
                      color="inherit"
                      className="filterBtn"
                      onClick={handleProfileMenuOpen}
                      disabled={PendingStatus ? true : false}
                    >
                      <img
                        className="wh50"
                        src={
                          userProfileData?.avatar?.url &&
                          userProfileData?.avatar?.url !== null
                            ? userProfileData?.avatar?.url
                            : profile
                        }
                        alt="profile"
                        onError={handleOnError}
                      />
                    </IconButton>
                  </Box>
                  <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                    <IconButton
                      size="large"
                      aria-label="show more"
                      aria-controls={mobileMenuId}
                      aria-haspopup="true"
                      onClick={handleMobileMenuOpen}
                      color="inherit"
                    >
                      <MoreIcon />
                    </IconButton>
                  </Box>
                  <Box>
                    <IconButton
                      aria-label="show more"
                      aria-controls={popoverMenuId}
                      aria-haspopup="true"
                      onClick={handlePopoverMenuOpen}
                      color="inherit"
                    ></IconButton>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
        {renderMobileMenu}
        {renderMenu}
        {renderPopoverMenu}
        {open && (
          <CommonSosDialog
            open={open}
            handleClose={handleClose}
            sosAlertData={sosAlertData}
          />
        )}
      </Box>
    </div>
  );
}

export default Header;
